import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

import './index.scss';

new Swiper('.banner-swiper', {
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

new Swiper('.news-swiper', {
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

document.querySelectorAll('.treatment-item .list').forEach((ele) => {
  const items = ele.querySelectorAll('.item');
  items[0].classList.add('image');
  items[0].style.backgroundImage = `url(${items[0].dataset.original})`;
  items.forEach((ele) => {
    ele.addEventListener('mouseover', () => {
      for (const iterator of items) {
        iterator.classList.remove('image');
        iterator.style.backgroundImage = '';
      }
      ele.style.backgroundImage = `url(${ele.dataset.original})`;
      ele.classList.add('image');
    });
  });
});